import React, { FunctionComponent } from 'react';
import { Typography, Colors } from '@inplayer-org/inplayer-ui';
import styled from 'styled-components';
import { AiOutlineWarning } from 'react-icons/ai';

const ContentWrapper = styled.div`
  display: flex;
  padding: 15px;
  margin-bottom: 30px;
  border: 1px solid ${Colors.gray};
  border-radius: 5px;
  background: ${Colors.lightGray};
`;

const StyledWarningIcon = styled(AiOutlineWarning)`
  color: ${Colors.red};
  width: 1.5em;
  height: 1.5em;
  margin-right: 0.5rem;
`;

const AttentionMessage: FunctionComponent = () => {
  return (
    <ContentWrapper>
      <StyledWarningIcon />
      <Typography variant="p">By using this feature you&apos;ll incur charges.</Typography>
    </ContentWrapper>
  );
};
export default AttentionMessage;
